<template>
  

    <!-- strat show api respons -->
    
      <form @submit.prevent="handleSubmit">
        <b-row>
          <b-col cols="12" sm="6" md="4">
            <!-- {{this.$v.user['fa_name'].$dirty}} -->
            <b-form-group label="نام:">
               <b-form-input
            id="example-input-1"
            v-model="$v.user.fa_name.$model"
            :state="validateState('fa_name')"
            
          ></b-form-input>

          <b-form-invalid-feedback
            v-if="!$v.user.fa_name.required"
            id="input-1-live-feedback"
            >نام را وارد کنید</b-form-invalid-feedback
          >
          <b-form-invalid-feedback
            v-else-if="!$v.user.fa_name.fachars"
            id="input-1-live-feedback"
            >نام را با حروف فارسی وارد کنید</b-form-invalid-feedback
          >
          <b-form-invalid-feedback
            v-else-if="!$v.user.fa_name.minLength"
            id="input-1-live-feedback"
            >نام باید حداقل ۳ کاراکتر باشد</b-form-invalid-feedback
          >
            </b-form-group>
          </b-col>
          <b-col cols="12" sm="6" md="4">
            <b-form-group label="نام خانوادگی:">
              <b-form-input
            id="example-input-1"
            v-model="$v.user.fa_family.$model"
            :state="validateState('fa_family')"
            
          ></b-form-input>

          <b-form-invalid-feedback
            v-if="!$v.user.fa_family.required"
            id="input-1-live-feedback"
            >نام خانوادگی را وارد کنید</b-form-invalid-feedback
          >
          <b-form-invalid-feedback
            v-else-if="!$v.user.fa_family.fachars"
            id="input-1-live-feedback"
            >نام خانوادگی را با حروف فارسی وارد کنید</b-form-invalid-feedback
          >
          <b-form-invalid-feedback
            v-else-if="!$v.user.fa_family.minLength"
            id="input-1-live-feedback"
            >نام خانوادگی باید حداقل ۳ کاراکتر باشد</b-form-invalid-feedback
          >
            </b-form-group>
          </b-col>
          <b-col cols="12" sm="6" md="4">
            <b-form-group label="نام پدر:">
              <b-form-input
            id="example-input-1"
            v-model="$v.user.fa_father.$model"
            
            :state="validateState('fa_father')"
          ></b-form-input>
          <b-form-invalid-feedback
            v-if="!$v.user.fa_father.required"
            id="input-1-live-feedback"
            >نام پدر را وارد کنید</b-form-invalid-feedback
          >
          <b-form-invalid-feedback
            v-else-if="!$v.user.fa_father.fachars"
            id="input-1-live-feedback"
            >نام پدر را با حروف فارسی وارد کنید</b-form-invalid-feedback
          >
          <b-form-invalid-feedback
            v-else-if="!$v.user.fa_father.minLength"
            id="input-1-live-feedback"
            >نام پدر باید حداقل ۳ کاراکتر باشد</b-form-invalid-feedback
          >
            </b-form-group>
          </b-col>
         
          <b-col cols="12" sm="6" md="4">
            <b-form-group
              id="example-input-group-1"
              label="نام به انگلیسی:"
              label-for="example-input-1"
            >
              <b-form-input
                id="example-input-1"
                v-model="$v.user.en_name.$model"
                :state="validateState('en_name')"
              ></b-form-input>
              <b-form-invalid-feedback
                v-if="!$v.user.en_name.required"
                id="input-1-live-feedback"
                >وارد کردن نام انگلیسی اجباری می باشد.</b-form-invalid-feedback
              >
              <b-form-invalid-feedback
                v-else-if="!$v.user.en_name.enchars"
                id="input-1-live-feedback"
                >نام انگلیسی را با حروف انگلیسی وارد
                کنید</b-form-invalid-feedback
              >
              <b-form-invalid-feedback
                v-else-if="!$v.user.en_name.minLength"
                id="input-1-live-feedback"
                >نام انگلیسی باید حداقل ۳ کاراکتر باشد</b-form-invalid-feedback
              >
            </b-form-group>
          </b-col>
          <b-col cols="12" sm="6" md="4">
            <b-form-group label="نام خانوادگی به انگلیسی:">
              <b-form-input
                v-model="$v.user.en_family.$model"
                :state="validateState('en_family')"
                id="example-input-1"
              ></b-form-input>
              <b-form-invalid-feedback
                v-if="!$v.user.en_family.required"
                id="input-1-live-feedback"
                >وارد کردن نام خانوادگی انگلیسی اجباری می
                باشد.</b-form-invalid-feedback
              >
              <b-form-invalid-feedback
                v-else-if="!$v.user.en_family.enchars"
                id="input-1-live-feedback"
                >نام خانوادگی انگلیسی را با حروف انگلیسی وارد
                کنید</b-form-invalid-feedback
              >
              <b-form-invalid-feedback
                v-else-if="!$v.user.en_family.minLength"
                id="input-1-live-feedback"
                >نام خانوادگی انگلیسی باید حداقل ۳ کاراکتر
                باشد</b-form-invalid-feedback
              >
            </b-form-group>
          </b-col>
          <b-col cols="12" sm="6" md="4">
            <b-form-group label="نام پدر به انگلیسی:">
              <b-form-input
                v-model="$v.user.en_father.$model"
                :state="validateState('en_father')"
                id="example-input-1"
              ></b-form-input>
              <b-form-invalid-feedback
                v-if="!$v.user.en_father.required"
                id="input-1-live-feedback"
                >وارد کردن نام پدر به انگلیسی اجباری می
                باشد.</b-form-invalid-feedback
              >
              <b-form-invalid-feedback
                v-else-if="!$v.user.en_father.enchars"
                id="input-1-live-feedback"
                >نام پدر به انگلیسی را با حروف انگلیسی وارد
                کنید</b-form-invalid-feedback
              >
              <b-form-invalid-feedback
                v-else-if="!$v.user.en_father.minLength"
                id="input-1-live-feedback"
                >نام پدر به انگلیسی باید حداقل ۳ کاراکتر
                باشد</b-form-invalid-feedback
              >
            </b-form-group>
          </b-col>
           <b-col cols="12" sm="6" md="4">
            <b-form-group
              id="example-input-group-1"
              label="جنسیت:"
              label-for="example-input-1"
            >
              <MDDropdown
                :state="validateState('mdid18_gender')"
                v-bind:group="18"
                v-model="$v.user.mdid18_gender.$model"
              ></MDDropdown>
              <b-form-invalid-feedback v-if="!$v.user.mdid18_gender.required" id="input-1-live-feedback"
                >وارد کردن جنسیت اجباری است</b-form-invalid-feedback
              >
            </b-form-group>
          </b-col>
          <b-col cols="12" sm="6" md="4">
            <b-form-group label="کد ملی:">
              <b-form-input
            id="example-input-1"
            
            v-model="$v.user.national_card_number.$model"
            :state="validateState('national_card_number')"
          ></b-form-input>
          <b-form-invalid-feedback
            v-if="!$v.user.national_card_number.required"
            id="input-1-live-feedback"
            >کد ملی را وارد کنید</b-form-invalid-feedback
          >
          <b-form-invalid-feedback
            v-else-if="!$v.user.national_card_number.numbers"
            id="input-1-live-feedback"
            >کد ملی فقط باید عدد باشد</b-form-invalid-feedback
          >
          <b-form-invalid-feedback
            v-else-if="!$v.user.national_card_number.minLength"
            id="input-1-live-feedback"
            >کد ملی باید حداقل 10 کاراکتر باشد</b-form-invalid-feedback
          >
            </b-form-group>
          </b-col>
          <b-col cols="12" sm="6" md="4">
            <b-form-group label="شماره شناسنامه:">
              <b-form-input
                id="example-input-1"
                v-model="$v.user.id_number.$model"
                :state="validateState('id_number')"
              ></b-form-input>
              <b-form-invalid-feedback
                v-if="!$v.user.id_number.required"
                id="input-1-live-feedback"
                >شماره شناسنامه را وارد کنید</b-form-invalid-feedback
              >
              <b-form-invalid-feedback
                v-else-if="!$v.user.id_number.numbers"
                id="input-1-live-feedback"
                >شماره شناسنامه فقط باید عدد باشد</b-form-invalid-feedback
              >
              <b-form-invalid-feedback
                v-else-if="!$v.user.id_number.idnumbers"
                id="input-1-live-feedback"
                >شماره شناسنامه عدد 0 نباشد</b-form-invalid-feedback
              >
            </b-form-group>
          </b-col>
          <b-col cols="12" sm="6" md="4">
            <b-form-group
              id="example-input-group-1"
              label="تاریخ تولد:"
              label-for="example-input-1"
              :state="validateState('birth_date')"
            >
              <date-picker
                clearable
                required
                v-model="$v.user.birth_date.$model"
                :max="maxDate"
                :state="validateState('birth_date')"
              ></date-picker>
              <b-form-invalid-feedback v-if="!$v.user.birth_date.required" id="input-1-live-feedback"
                >وارد کردن تاریخ تولد اجباری است</b-form-invalid-feedback
              >
            </b-form-group>
          </b-col>
          <b-col cols="12" sm="6" md="4">
            <b-form-group
              id="example-input-group-1"
              label="کد شهر:"
              label-for="example-input-1"
            >
              <b-form-input
                id="example-input-1"
                v-model="$v.user.pre_phone.$model"
                :state="validateState('pre_phone')"
                
              ></b-form-input>
              <b-form-invalid-feedback
                v-if="!$v.user.pre_phone.required"
                id="input-1-live-feedback"
                >کد شهر را وارد کنید</b-form-invalid-feedback
              >
              <b-form-invalid-feedback
                v-if="!$v.user.pre_phone.numbers"
                id="input-1-live-feedback"
                >کد شهر فقط باید عدد باشد</b-form-invalid-feedback
              >
              <b-form-invalid-feedback
                v-else-if="!$v.user.pre_phone.minLength"
                id="input-1-live-feedback"
                >کد شهر باید حداقل 3 کاراکتر باشد</b-form-invalid-feedback
              >
              <b-form-invalid-feedback
                v-else-if="!$v.user.pre_phone.maxLength"
                id="input-1-live-feedback"
                >کد شهر باید حداکثر 3 کاراکتر باشد</b-form-invalid-feedback
              >
            </b-form-group>
          </b-col>
          <b-col cols="12" sm="6" md="4">
            <b-form-group
              id="example-input-group-1"
              label="تلفن ثابت:"
              label-for="example-input-1"
            >
              <b-form-input
                id="example-input-1"
                v-model="$v.user.phone.$model"
                :state="validateState('phone')"
                
              ></b-form-input>
              <b-form-invalid-feedback
                v-if="!$v.user.phone.required"
                id="input-1-live-feedback"
                >تلفن ثابت را وارد کنید</b-form-invalid-feedback
              >
              <b-form-invalid-feedback
                v-if="!$v.user.phone.numbers"
                id="input-1-live-feedback"
                >تلفن ثابت فقط باید عدد باشد</b-form-invalid-feedback
              >
              <b-form-invalid-feedback
                v-else-if="!$v.user.phone.minLength"
                id="input-1-live-feedback"
                >تلفن ثابت باید حداقل 5 کاراکتر باشد</b-form-invalid-feedback
              >
              <b-form-invalid-feedback
                v-else-if="!$v.user.phone.maxLength"
                id="input-1-live-feedback"
                >تلفن ثابت باید حداکثر 8 کاراکتر باشد</b-form-invalid-feedback
              >
            </b-form-group>
          </b-col>
          <b-col cols="12" sm="6" md="4">
            <b-form-group
              id="example-input-group-1"
              label="استان:"
              label-for="example-input-1"
            >
              <MDDropdown
                
                v-bind:group="4"
                v-model="$v.user.mdid4_province.$model"
                :state="validateState('mdid4_province')"
              ></MDDropdown>
              <b-form-invalid-feedback id="input-1-live-feedback"
                >وارد کردن نام شرکت اجباری است</b-form-invalid-feedback
              >
            </b-form-group>
          </b-col>
          <b-col cols="12" sm="6" md="4">
            <b-form-group
              id="example-input-group-1"
              label="شهر:"
              label-for="example-input-1"
            >
              <MDDropdown
                v-model="$v.user.mdid5_city.$model"
                v-bind:group="5"
                v-bind:parent="$v.user.mdid4_province.$model"
                :state="validateState('mdid5_city')"
                
              ></MDDropdown>
              <b-form-invalid-feedback id="input-1-live-feedback"
                >وارد کردن نام شرکت اجباری است</b-form-invalid-feedback
              >
            </b-form-group>
          </b-col>
          <b-col cols="12" sm="6" md="4">
            <b-form-group
              id="example-input-group-1"
              label="کد پستی:"
              label-for="example-input-1"
            >
              <b-form-input
                id="example-input-1"
                min="1000000000"
                mask="##########"
                v-model="$v.user.postalCode.$model"
                :state="validateState('postalCode')"
                
              ></b-form-input>
              <b-form-invalid-feedback
                v-if="!$v.user.postalCode.required"
                id="input-1-live-feedback"
                >کد پستی را وارد کنید</b-form-invalid-feedback
              >
              <b-form-invalid-feedback
                v-if="!$v.user.postalCode.numbers"
                id="input-1-live-feedback"
                >کد پستی فقط باید عدد باشد</b-form-invalid-feedback
              >
              <b-form-invalid-feedback
                v-else-if="
                  !$v.user.postalCode.minLength || !$v.user.postalCode.maxLength
                "
                id="input-1-live-feedback"
                >کد پستی باید 10 کاراکتر باشد</b-form-invalid-feedback
              >
            </b-form-group>
          </b-col>
          <b-col cols="12" sm="6" md="12">
            <b-form-group
              id="example-input-group-1"
              label="آدرس:"
              label-for="example-input-1"
            >
              <b-form-input
                id="example-input-1"
                v-model="$v.user.address.$model"
                :state="validateState('address')"
                
              ></b-form-input>
              <b-form-invalid-feedback v-if="!$v.user.address.required" id="input-1-live-feedback"
                >وارد کردن آدرس اجباری است</b-form-invalid-feedback
              >
              <b-form-invalid-feedback v-else-if="!$v.user.address.minLength" id="input-1-live-feedback"
                >آدرس باید حداقل ۱۰ کاراکتر باشد</b-form-invalid-feedback
              >
            </b-form-group>
          </b-col>
        </b-row>
        <div class="form-group">
          <button
            class="btn btn-primary"
            :class="submitted ? 'spinner spinner-light spinner-right' : ''"
          >
            ثبت اطلاعات حقیقی
          </button>
        </div>
      </form>
    
    <!-- end of show api respons -->
</template>


<script>
// import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import { GETUSER } from "@/core/services/store/getUser.module";
import { validationMixin } from "vuelidate";
import { required ,minLength ,maxLength} from "vuelidate/lib/validators";
import MDDropdown from "../../components/MDDropdown";
import persianDate from '../../helpers/persianDate';

// import httpHelper from "../../helpers/httpHelper";

const enchars = (value, vm) => !/[^A-Za-z\s]/.test(value);
const fachars = (value, vm) => /^[\u0600-\u06FF\s]+$/.test(value);
const numbers = (value, vm) => !/[^0-9]/.test(value);
const idnumbers = (value, vm) => {
  return parseInt(value) != 0;
};
// const iban = (value, vm) => /^\b(I|i)(R|r)[0-9]{24}$/.test(value);

export default {
  name: "realInformation",
  props: ["submitted"],
  mixins: [validationMixin],
  components: { MDDropdown },
  data() {
    return {
      user: {
        
        fa_name: "",
        fa_family: "",
        fa_father: "",
        en_name: "",
        en_family: "",
        en_father: "",
       mdid18_gender: "",
       mdid4_province: "",
       mdid5_city: "",
        phone: "",
        postalCode: "",
        national_card_number: "",
        id_number: "",
        merchant_type: 0,
        pre_phone: "",
        address: "",
        birth_date: ""
      },
      Options: [],
      data: [],
      maxDate: "",
      loadedUserInformation: {
       
      },
    };
  },
  watch: {},
  validations: {
    user: {
      fa_name: {
        fachars,
        required,
        minLength: minLength(3),
      },
      fa_family: {
        fachars,
        required,
        minLength: minLength(3),
      },
      en_name: {
        enchars,
        required,
        minLength: minLength(3),
      },
      en_family: {
        enchars,
        required,
        minLength: minLength(3),
      },
      national_card_number: {
        required,
        numbers,
        minLength: minLength(10),
      },
      id_number: {
        required,
        numbers,
        minLength: minLength(1),
        idnumbers,
      },
      pre_phone: {
        required,
        numbers,
        minLength: minLength(3),
        maxLength: maxLength(3),
      },
      fa_father: { fachars, required, minLength: minLength(3) },
      en_father: { enchars, required, minLength: minLength(3) },
      phone: { required, minLength: minLength(5), maxLength: maxLength(8) ,numbers},
      mdid18_gender: { required },
      birth_date: { required },
      mdid4_province: {
        required,
      },
      mdid5_city: {
        required,
      },
      address: {
        required,
        minLength: minLength(10),
      },
      postalCode: {
        required,
        numbers,
        minLength: minLength(10),
        maxLength: maxLength(10),
      },
    },

  },
  computed: {
    // loadedResultInquiry() {
    //   return this.$store.getters.loadedResultInquiry;
    // },
  //   loadedUserInformation(){
      
  //   return this.$store.getters.loadedUserInformation;
  //  }
  },
  mounted() {
    // this.$store.dispatch(SET_BREADCRUMB, [
    //   { title: "اینماد " },
    //   { title: "اطلاعات کاربری-حقیقی" },
    // ]);
    // this.getBusinessType();
    let query;
    query = this.$route.query.status;
    if (query!==undefined) {
    this.getUser();
    }
  },
  created() {
    //this.form = this.value;
    var d = new Date();
    var year = d.getFullYear();
    var month = d.getMonth();
    var day = d.getDate();
    var c = new Date(year - 18, month, day);
    this.maxDate = persianDate.getDateByFormat(c);


  },
  methods: {
     getUser() {
      this.$store.dispatch(GETUSER).then((data)=>{
        Object.assign(this.loadedUserInformation,data);
         this.$v.user.fa_name.$model=this.loadedUserInformation.fa_name;
       this.$v.user.fa_family.$model=this.loadedUserInformation.fa_family;
      this.$v.user.en_name.$model=this.loadedUserInformation.en_name;
       this.$v.user.en_family.$model=this.loadedUserInformation.en_family;
       this.$v.user.national_card_number.$model=this.loadedUserInformation.national_card_number;
       this.$v.user.id_number.$model=this.loadedUserInformation.id_number;
      this.$v.user.pre_phone.$model=this.loadedUserInformation.pre_phone;
       this.$v.user.fa_father.$model=this.loadedUserInformation.fa_father;
       this.$v.user.en_father.$model=this.loadedUserInformation.en_father;
       this.$v.user.phone.$model=this.loadedUserInformation.phone;
       this.$v.user.mdid18_gender.$model=this.loadedUserInformation.mdid18_gender;
       this.$v.user.birth_date.$model=this.loadedUserInformation.birth_date;
       this.$v.user.mdid4_province.$model=this.loadedUserInformation.mdid4_province;
       this.$v.user.mdid5_city.$model=this.loadedUserInformation.mdid5_city;
       this.$v.user.address.$model=this.loadedUserInformation.address;
       this.$v.user.postalCode.$model=this.loadedUserInformation.postalCode;
      });
    },
    handleSubmit(e) {
      // stop here if form is invalid
      this.$v.$touch();
      if (this.$v.user.$anyError) {
        return;
      }
      
      Object.assign(this.user, {
      fa_name: this.$v.user.fa_name.$model,
      fa_family: this.$v.user.fa_family.$model,
      en_name: this.$v.user.en_name.$model,
      en_family: this.$v.user.en_family.$model,
      national_card_number: this.$v.user.national_card_number.$model,
      id_number: this.$v.user.id_number.$model,
      pre_phone: this.$v.user.pre_phone.$model,
      fa_father: this.$v.user.fa_father.$model,
      en_father: this.$v.user.en_father.$model,
      phone: this.$v.user.phone.$model,
      mdid18_gender: this.$v.user.mdid18_gender.$model,
      birth_date: this.$v.user.birth_date.$model,
      mdid4_province: this.$v.user.mdid4_province.$model,
      mdid5_city: this.$v.user.mdid5_city.$model,
      address: this.$v.user.address.$model,
      postalCode: this.$v.user.postalCode.$model,
      });
      this.$emit("validattion", this.user);
    },
    validateState(name) {
      const { $dirty, $error } = this.$v.user[name];
      return $dirty ? !$error : null;
    },
    // setENChars(field) {
    //   this.$v.user[field].$model = this.user[field].toEnDigits();
    //   console.log(this.user[field]);
    // },
    // getBusinessType() {
    //   httpHelper.getData("enamad/get-mdid9-metadata").then((res) => {
    //     this.data = res.result.map((element) => {
    //       return {
    //         parent: element.parent_id,
    //         value: element.id,
    //         text: element.title,
    //       };
    //     });
    //     this.Options = [];
    //     this.data.forEach((element) => {
    //       if (element.parent == this.parent) {
    //         this.Options.push(element);
    //       }
    //     });
    //   });
    // },
  },
};
</script>

<style>
</style>

